import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface DialogData {
  type: string,
  title: string,
  message: string;
  closeButton: string;
  notes: Array<string>;
  options: Array<string>;
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  public residuo = 0;

  public data: DialogData = {
    type: '',
    title: '',
    message: '',
    closeButton: '',
    options: ['Ok'],
    notes: []
  }

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public tmp: DialogData,
  ) {

  }

  ngOnInit(): void {
    console.log(this.tmp);
    if (this.tmp.options && Array.isArray(this.tmp.options) && this.tmp.options.length > 0 && this.tmp.options.every(item => typeof item === "string")) {
      if (this.tmp.options.length) {
        this.data.options = this.tmp.options;
      }
    } else if (this.tmp.options) {
      alert(`variable type not allowed, 'options' variable must be an array of type strings`);
      this. onNoClick();
    }

    if (this.tmp.notes && Array.isArray(this.tmp.notes) && this.tmp.notes.length > 0 && this.tmp.notes.every(item => typeof item === "string")) {
      if (this.tmp.notes.length) {
        this.data.notes = this.tmp.notes;
      }
    } else if (this.tmp.notes) {
      alert(`variable type not allowed, 'notes' variable must be an array of type strings`);
      this. onNoClick();
    }

    if (this.tmp.type && typeof this.tmp.type === "string") {
      this.data.type = this.tmp.type;
    } else if (this.tmp.type) {
      alert(`variable type not allowed, 'type' variable must be an type strings`);
      this. onNoClick();
    }

    if (this.tmp.title && typeof this.tmp.title === "string") {
      this.data.title = this.tmp.title;
    } else if (this.tmp.title) {
      alert(`variable type not allowed, 'type' variable must be an type strings`);
      this. onNoClick();
    }

    if (this.tmp.message && typeof this.tmp.message === "string") {
      this.data.message = this.tmp.message;
    } else if (this.tmp.message) {
      alert(`variable type not allowed, 'type' variable must be an type strings`);
      this. onNoClick();
    }

    if (this.tmp.closeButton && typeof this.tmp.closeButton === "string") {
      this.data.closeButton = this.tmp.closeButton;
    } else if (this.tmp.closeButton) {
      alert(`variable type not allowed, 'type' variable must be an type strings`);
      this. onNoClick();
    }

    this.residuo = this.data.options.length % 2;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
